import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SimpleFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-card border-t border-green-100 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-text-primary">{t('footer.legalName')}</h3>
            <p className="text-text-secondary text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <a
              href={`mailto:${t('footer.email')}`}
              className="inline-block text-text-secondary text-sm hover:text-green-600 transition-colors"
            >
              {t('footer.email')}
            </a>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-medium text-text-primary">{t('footer.quickLinks.title')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-text-secondary hover:text-green-600 transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/projects" className="text-text-secondary hover:text-green-600 transition-colors">{t('nav.work')}</Link></li>
              <li><Link to="/contact" className="text-text-secondary hover:text-green-600 transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-green-100 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-text-secondary">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
          <p className="text-xs text-text-secondary mt-2 sm:mt-0">
            {t('footer.builtWith')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SimpleFooter;
